export function Checkbox(props) {
  const { label, ...rest } = props;
  return (
    <label>
      <checkbox {...rest} />
      {label}
    </label>
  );
}

Checkbox.defaultProps = {
  color: 'primary',
};

export default Checkbox;
